import {equals} from 'ramda';

import {SaveSaleVehicleLeasingBody} from '@dms/api/vehicle';

import {compareLeasingCells} from './compareLeasingCells';
import {normalizeDecimalValue} from './normalizeDecimalValue';
import {normalizeMoneyValue} from './normalizeMoneyValue';

function normalizeLeasingBody(vehicleLeasingBody: SaveSaleVehicleLeasingBody) {
  return {
    ...vehicleLeasingBody,
    rateMatrixCells: [...vehicleLeasingBody.rateMatrixCells]
      .map((cell) => ({
        ...cell,
        monthlyRate: normalizeMoneyValue(cell.monthlyRate) ?? cell.monthlyRate,
        nominalRate: normalizeDecimalValue(cell.nominalRate),
        apr: normalizeDecimalValue(cell.apr),
      }))
      .sort(compareLeasingCells),
    commonParameters: {
      ...vehicleLeasingBody.commonParameters,
      listPrice: normalizeMoneyValue(vehicleLeasingBody.commonParameters.listPrice),
      vatRate: normalizeDecimalValue(vehicleLeasingBody.commonParameters.vatRate),
      downPayment: normalizeMoneyValue(vehicleLeasingBody.commonParameters.downPayment),
      excessMileageCost: normalizeMoneyValue(vehicleLeasingBody.commonParameters.excessMileageCost),
      underMileageCredit: normalizeMoneyValue(
        vehicleLeasingBody.commonParameters.underMileageCredit
      ),
      vehicleTransferAmount: normalizeMoneyValue(
        vehicleLeasingBody.commonParameters.vehicleTransferAmount
      ),
      vehicleRegistrationAmount: normalizeMoneyValue(
        vehicleLeasingBody.commonParameters.vehicleRegistrationAmount
      ),
      vehicleDeliveryAmount: normalizeMoneyValue(
        vehicleLeasingBody.commonParameters.vehicleDeliveryAmount
      ),
      maintenanceMonthly: normalizeMoneyValue(
        vehicleLeasingBody.commonParameters.maintenanceMonthly
      ),
      wearMonthly: normalizeMoneyValue(vehicleLeasingBody.commonParameters.wearMonthly),
      maintenanceAndWearMonthly: normalizeMoneyValue(
        vehicleLeasingBody.commonParameters.maintenanceAndWearMonthly
      ),
      vehicleTaxMonthly: normalizeMoneyValue(vehicleLeasingBody.commonParameters.vehicleTaxMonthly),
      liabilityInsuranceMonthly: normalizeMoneyValue(
        vehicleLeasingBody.commonParameters.liabilityInsuranceMonthly
      ),
      liabilityInsuranceDeductible: normalizeMoneyValue(
        vehicleLeasingBody.commonParameters.liabilityInsuranceDeductible
      ),
      comprehensiveInsuranceMonthly: normalizeMoneyValue(
        vehicleLeasingBody.commonParameters.comprehensiveInsuranceMonthly
      ),
      comprehensiveInsuranceDeductible: normalizeMoneyValue(
        vehicleLeasingBody.commonParameters.comprehensiveInsuranceDeductible
      ),
      tiresMonthly: normalizeMoneyValue(vehicleLeasingBody.commonParameters.tiresMonthly),
      inspectionMonthly: normalizeMoneyValue(vehicleLeasingBody.commonParameters.inspectionMonthly),
      returnValueInsuranceMonthly: normalizeMoneyValue(
        vehicleLeasingBody.commonParameters.returnValueInsuranceMonthly
      ),
      specialConditionCodes: [...vehicleLeasingBody.commonParameters.specialConditionCodes].sort(),
    },
  };
}

export function areLeasingBodiesEqual(
  left: SaveSaleVehicleLeasingBody,
  right: SaveSaleVehicleLeasingBody
) {
  return equals(normalizeLeasingBody(left), normalizeLeasingBody(right));
}
